export type NavItem = {
  label: string;
  href: string;
};

export const sectionIds = {
  problem: "problem",
  reveal: "co-odhalime",
  how: "jak-to-funguje",
  report: "report",
  proof: "dukazy",
  faq: "faq",
  contact: "kontakt",
} as const;

export const navigation: NavItem[] = [
  { label: "Co odhalíme", href: `#${sectionIds.reveal}` },
  { label: "Jak to funguje", href: `#${sectionIds.how}` },
  { label: "Report", href: `#${sectionIds.report}` },
  { label: "FAQ", href: `#${sectionIds.faq}` },
];

export const legalNavigation: NavItem[] = [
  { label: "Ochrana osobních údajů", href: "/ochrana-osobnich-udaju" },
  { label: "Cookies", href: "/cookies" },
];
